import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';

export default {
    install(Vue) {
        Vue.prototype.getPdf = function () {
            try {
                // 隐藏导出按钮
                const exportSec = document.querySelector('#exportSec');
                if (exportSec) exportSec.style.display = "none";

                // 创建并显示loading覆盖层
                const loadingOverlay = document.createElement('div');
                loadingOverlay.style.position = 'fixed';
                loadingOverlay.style.top = '0';
                loadingOverlay.style.left = '0';
                loadingOverlay.style.width = '100%';
                loadingOverlay.style.height = '100%';
                loadingOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                loadingOverlay.style.display = 'flex';
                loadingOverlay.style.justifyContent = 'center';
                loadingOverlay.style.alignItems = 'center';
                loadingOverlay.style.zIndex = '9999';

                // Spinner element
                const spinner = document.createElement('div');
                spinner.style.border = '8px solid #f3f3f3'; // Light gray
                spinner.style.borderTop = '8px solid #fc9153'; // Blue
                spinner.style.borderRadius = '50%';
                spinner.style.width = '50px';
                spinner.style.height = '50px';
                spinner.style.animation = 'spin 1s linear infinite';
                loadingOverlay.appendChild(spinner);

                document.body.appendChild(loadingOverlay);

                // Add keyframes for the spinning animation
                const style = document.createElement('style');
                style.innerHTML = `
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `;
                document.head.appendChild(style);

                // 获取目标 DOM 元素
                const ele = document.querySelector('#pdfDom');
                if (!ele) throw new Error('Target element not found');

                const pdfName = (localStorage.aqbCofeLang === "en-US" ? "Curve.pdf" : "曲线.pdf");

                // 保存并修改样式
                const originalPadding = ele.style.padding;
                const originalBackground = document.body.style.backgroundColor;
                const originalBorder = ele.style.border;
                const originalBorderRadius = ele.style.borderRadius;
                const originalWidth1 = ele.style.width;

                // 获取 canvas 和 #hastable
                const reportChart = ele.querySelector('#reportChart');
                const reportChartChildDiv = reportChart ? reportChart.querySelector('div') : null;
                const canvas = reportChartChildDiv ? reportChartChildDiv.querySelector('canvas') : null;
                
                // 保存 canvas 的原始宽度
                const originalCanvasWidth = canvas ? canvas.style.width : null;
                const bodyWrapper = document.querySelector('#workForceTable .el-table__body-wrapper');
           
                bodyWrapper.style.height = `${bodyWrapper.scrollHeight}px`;
                document.getElementById('pdfDom').style.width = `${bodyWrapper.scrollWidth}px`;
                // 添加白色边框和圆角
                ele.style.border = '1px solid white';
                ele.style.borderRadius = '6px';
                ele.style.padding = '15px';
                document.body.style.backgroundColor = '#070809';

                // 调整 canvas 的宽度为原本的 80%
                if (canvas) {
                    const originalWidth = canvas.width; // 获取 canvas 的原始像素宽度
                    canvas.style.width = `${bodyWrapper.scrollWidth - 20}px`; // 设置为 82%
                }
                setTimeout(() => {
                     // 使用 html2canvas 渲染 DOM 元素到 Canvas
                html2Canvas(ele, {
                    dpi: 300,
                    useCORS: true,
                    backgroundColor: '#070809', // 确保背景色在截屏中生效
                    scale: 1, // 设置为 1，避免缩放
                    logging: true, // 开启日志，便于调试
                    width: bodyWrapper.scrollWidth +40, // Ensure horizontal scrollbar content is captured
                }).then((canvas) => {
                    // 获取 Canvas 的宽高
                    const contentWidth = canvas.width;
                    const contentHeight = canvas.height;

                    // 将像素单位转换为毫米（1px = 0.264583mm）
                    const widthInMM = contentWidth * 0.264583;
                    const heightInMM = contentHeight * 0.264583;

                    // 根据 Canvas 的宽高设置 PDF 页面大小
                    const pdf = new JsPDF({
                        orientation: contentWidth > contentHeight ? 'landscape' : 'portrait', // 根据宽高比设置方向
                        unit: 'mm', // 使用毫米单位
                        format: [widthInMM, heightInMM], // 动态设置页面大小
                    });

                    // 将 Canvas 转换为图片并添加到 PDF
                    const pageData = canvas.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(pageData, 'JPEG', 0, 0, widthInMM, heightInMM);

                    // 保存 PDF
                    pdf.save(pdfName);
                }).catch((error) => {
                    console.error('Error generating PDF:', error);
                }).finally(() => {
                    // 隐藏loading覆盖层
                    document.body.removeChild(loadingOverlay);

                    // 恢复导出按钮
                    if (exportSec) exportSec.style.display = "block";

                    // 恢复原始样式
                    ele.style.padding = originalPadding;
                    ele.style.border = originalBorder;
                    ele.style.borderRadius = originalBorderRadius;
                    ele.style.width = originalWidth1;
                    document.body.style.backgroundColor = originalBackground;

                    // 恢复 canvas 的原始宽度
                    if (canvas) {
                        canvas.style.width = originalCanvasWidth;
                    }
                });
                }, 1000);
               
            } catch (error) {
                console.error('Error in getPdf function:', error);
                // 恢复导出按钮
                const exportSec = document.querySelector('#exportSec');
                if (exportSec) exportSec.style.display = "block";

                // 恢复原始样式
                const ele = document.querySelector('#pdfDom');
                if (ele) {
                    ele.style.padding = originalPadding;
                    ele.style.border = originalBorder;
                    ele.style.borderRadius = originalBorderRadius;
                }
                document.body.style.backgroundColor = originalBackground;

                // 恢复 canvas 的原始宽度
                const reportChart = ele ? ele.querySelector('#reportChart') : null;
                const reportChartChildDiv = reportChart ? reportChart.querySelector('div') : null;
                const canvas = reportChartChildDiv ? reportChartChildDiv.querySelector('canvas') : null;
                if (canvas) {
                    canvas.style.width = originalCanvasWidth;
                }
            }
        };
    }
};
